import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    const cycle = window.setInterval(() => {
      setVisible(true);
      showTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
      }, 5000);
    }, 12000);
    const initial = window.setTimeout(() => setVisible(true), 6000);
    const initialHide = window.setTimeout(() => {
      setVisible(false);
      setIndex(prev => (prev + 1) % purchaseNotifications.length);
    }, 11000);
    return () => {
      window.clearInterval(cycle);
      window.clearTimeout(showTimer);
      window.clearTimeout(initial);
      window.clearTimeout(initialHide);
    };
  }, [dismissed]);
  const item = purchaseNotifications[index];
  const minutes = index * 3 % 11 + 2;
  return <AnimatePresence data-id="element-34" data-mp="1fvivh9aen1f3">
      {visible && !dismissed ? <motion.div initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.35
    }} className="fixed bottom-24 left-3 right-3 sm:right-auto sm:max-w-xs z-40" role="status" data-id="element-35" data-mp="1fv0w43sg472y">
          <div className="relative flex items-start gap-3 rounded-2xl border border-navy/10 bg-white px-3.5 py-3 shadow-xl" data-id="element-36" data-mp="ia4u4qdupgg4">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brandred" aria-hidden="true" data-id="element-37" data-mp="s6hkbea6tc64" />
            <div className="pr-4" data-id="element-38" data-mp="28j508kvdcc3j">
              <p className="text-[13px] font-bold leading-snug text-navy" data-id="element-39" data-mp="28maqi3fqhk0u">
                {item.name} acaba de comprar Ruta Hipertensión
              </p>
              <p className="mt-0.5 text-[11px] text-navy/60" data-id="element-40" data-mp="2anjkzknjsh9x">
                {item.place} · hace {minutes} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-full p-1 text-navy/40 transition-colors hover:bg-navy/5 hover:text-navy" data-id="element-41" data-mp="2fph6kljf7o61">
              <XIcon className="h-3.5 w-3.5" data-id="element-42" data-mp="1rvz5nkcfe5eg" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}